import { apiRequest } from '@/api/client';
import type { DomainMetricsView, MetricSource, SiteTimelineView } from '@/types/api';

/** SEO data from outside sources (ADR-0050). */
export const seoMetricsApi = {
  network: () => apiRequest<{ siteId: string; domain: string; view: DomainMetricsView }[]>('/seo-metrics'),
  site: (siteId: string) => apiRequest<DomainMetricsView & { sources: MetricSource[] }>(`/sites/${siteId}/seo-metrics`),
  /** Every source read now; answers with the fresh view. */
  refresh: (siteId: string) => apiRequest<DomainMetricsView & { sources: MetricSource[] }>(`/sites/${siteId}/seo-metrics/refresh`, { method: 'POST', body: {} }),
  timeline: (siteId: string) => apiRequest<SiteTimelineView>(`/sites/${siteId}/seo-timeline`),
  /** Names typed in to be looked at before buying, read now; the page sends one at a time. */
  check: (domains: string) => apiRequest<{ results: DomainMetricsView[]; invalid: string[] }>('/seo-metrics/check', { method: 'POST', body: { domains } }),
};
